<div class="frame-content form-field-density-4">
     <mat-form-field class="full-width">
        <mat-label>URL</mat-label>
        <input matInput  placeholder="Preencher com sua URL" #inp>
        <button matSuffix mat-icon-button aria-label="Navigate" (click)="navigate(inp.value)">
            <mat-icon>search</mat-icon>
          </button>
      </mat-form-field>
      <mat-divider></mat-divider>
      <div class="pure-pusher" [hidden]="current_url==null">
        <iframe class="iframe-div"  target="_self" #iframe
            [src]="current_url" frameborder="0">
        </iframe>
      </div>
</div>
